import React, { useState, useEffect } from "react";
import { FormControl, Select, MenuItem, FormHelperText } from "@mui/material";
import { searchCustomerInfoList } from "../../../http/api/CustomerAPI";

const CustomerSelect = ({ name, onChange, value, error,validate, ...props }) => {
  const [listCustomer, setListCustomer] = useState([]);
  const [selectedValue, setSelectedValue] = useState(value);

  useEffect(() => {
    getCustomer();
  }, []);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  async function getCustomer() {
    try {
      const response = await searchCustomerInfoList({});
      setListCustomer(response.data?.listCustomerInfo ?? response.listCustomerInfo);
    } catch (error) {
      console.error("Failed to fetch customer types:", error);
    }
  }

  const handleChangeSelect = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };

  return (
    <FormControl {...props} error={!!error}>
      <Select
        id={name}
        value={selectedValue}
        onChange={handleChangeSelect} 
      >
        <MenuItem key={"customerSelect"} value={0}>
          未選択
        </MenuItem>
        {listCustomer.map((customer) => (
          <MenuItem key={customer.customerId} value={customer.customerId}>
            {customer.customerName}
          </MenuItem>
        ))}
      </Select>

      {error && <FormHelperText sx={{ color: "#d32f2f" ,  marginLeft: 0}}>{validate.errors.customerId}</FormHelperText>}
    </FormControl>
   
  );
};
export default CustomerSelect;
